import axios from './axios';

const aqiDashboardServices = {
  fetch: () => {
    const options = {
      method: 'GET',
      url: 'aqi-dashboards'
    };

    return axios(options);
  }
};

export default aqiDashboardServices;
